export default "__VITE_ASSET__DyGXsIU___"